import React from "react";
import "./plp.css";
import productLineImage from "../../../assets/service-pictures/product-line-printing.jpg";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import OurApproach from "./OurApproach";
import EnsureSecurity from "./EnsureSecurity";
import IndustriesWeServe from "./IndustriesWeServe";
import Benefits from "./Benefits";
import CallToAction from "./CallToAction";

const ProductLinePrinting = () => {
  return (
    <div className="plp-service-wrapper">
      <Particles title="Product Line Printing" image={productLineImage} />
      <HeroSection />
      <OurApproach />
      <IndustriesWeServe />
      <EnsureSecurity />
      <Benefits />
      <CallToAction />
    </div>
  );
};

export default ProductLinePrinting;
